import { css } from "styled-components";
import { fontSize, gutter } from "@app/styles/helpers/theme";
import { fromMedia, toMedia } from "@app/styles/helpers/mediaQueries";

export const CheckboxStyles = css`
    .checkbox + .checkbox {
        padding-top: ${gutter(2)};
    }
    .checkbox {
        position: relative;
        display: flex;

        & .portal-control-indicator {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 16px;
            min-width: 16px;
            height: 16px;
            min-height: 16px;
            ${toMedia.MD`
                width: 24px;
                min-width: 24px;
                height: 24px;
                min-height: 24px;
            `}
            border-radius: ${gutter(0.5)};
            .icon {
                padding: 0;
                line-height: unset;
                color: var(--dit-brand-color-neutral-00--map);
                ${toMedia.MD`
                    font-size: ${fontSize(14)};
                `}
                ${fromMedia.MD`
                    font-size: ${fontSize(10.5)};
                `}
            }
        }
        & .checkbox-label {
            margin-bottom: 0;
            user-select: none;
            &:not(:empty) {
                padding-left: ${gutter(1)};
                ${toMedia.MD`
                    padding-left: ${gutter(1.5)};
                `}
            }

            line-height: 16px;
            ${toMedia.MD`
                line-height: 24px;
            `}
            ${toMedia.MD`
                font-size: ${fontSize(16)};
            `}
        }

        & input {
            &.sr-only {
                position: absolute;
                opacity: 0;
                width: 16px;
                min-width: 16px;
                height: 16px;
                min-height: 16px;
                ${toMedia.MD`
                    width: 24px;
                    min-width: 24px;
                    height: 24px;
                    min-height: 24px;
                `}
            }
            & ~ .portal-control-indicator {
                background-color: var(--dit-brand-color-neutral-00--map);
                box-shadow: var(--dit-layout-shadow-checkbox-control-indicator-default--map);
            }
            //Default
            &:not(:checked):not(.indeterminate) ~ .portal-control-indicator > .icon {
                display: none;
            }
            // Selected and indeterminate
            &:checked ~ .portal-control-indicator,
            &.indeterminate ~ .portal-control-indicator {
                background-color: var(--dit-layout-color-checkbox-indicator-background--map);
                box-shadow: none;
            }

            &:not(:disabled):not(:checked):not(.indeterminate) {
                &:hover {
                    cursor: pointer;
                }
                & ~ .portal-control-indicator:hover,
                &:hover ~ .portal-control-indicator {
                    background-color: var(--dit-layout-color-checkbox-hover-background--map);
                }
            }
            &:not(:disabled):checked,
            &:not(:disabled).indeterminate {
                &:hover {
                    cursor: pointer;
                }
                & ~ .portal-control-indicator:hover,
                &:hover ~ .portal-control-indicator {
                    cursor: pointer;
                    background-color: var(--dit-layout-color-checkbox-selected-hover-background--map);
                }
            }
            // Disabled
            &:disabled {
                // Default disabled
                & ~ .portal-control-indicator {
                    background-color: var(--dit-layout-color-checkbox-disabled-background--map);
                    box-shadow: var(--dit-layout-shadow-checkbox-disabled--map);
                }
                // Selected disabled
                &:checked ~ .portal-control-indicator,
                &.indeterminate ~ .portal-control-indicator {
                    background-color: var(--dit-layout-color-checkbox-selected-disabled-background--map);
                }
            }
            // Error
            &:not(.indeterminate):not(:focus):not(:checked).error ~ .portal-control-indicator {
                box-shadow: var(--dit-layout-shadow-checkbox-error--map);
            }

            &:focus ~ .portal-control-indicator {
                outline-style: none;
                box-shadow: var(--dit-layout-shadow-checkbox-focus--map);
            }
        }
    }
`;
